import PostbackActions from '../../../../actions/PostbackActions';
import CustomNotify from '../../../Notify';
import UserStore from '../../../../stores/UserStore';
import { push } from '/src/utils/navigation';

export const actions = {
    onSave(state) {
        let params = {
            title: state.title,
            url: state.url,
            method: state.method,
            currency: state.currency,
            locale: state.locale,
            conversion_statuses: state.conversionStatuses.join(','),
            goal_action_ids: state.goalActionIds.join(','),
            parameters: JSON.stringify(state.queryParams),
            track_parameter: JSON.stringify(state.trackParameter),
            success_string: state.successString
        };

        if (!state.trackParameter.name || !state.trackParameter.value) {
            params.unset_track_parameter = '1';
            delete params.track_parameter;
        }

        if (state.edit) {
            params.id = state.id;
            params.unset_conversion_statuses = !state.conversionStatuses.length ? '1' : '';
            params.unset_goal_action_ids = !state.goalActionIds.length ? '1' : '';

            if (!state.queryParams.length) {
                params.unset_parameters = '1';
                delete params.parameters;
            }

            if (!state.successString) {
                params.unset_success_string = '1';
                delete params.success_string;
            }

            PostbackActions.editPostback(params, () => {
                actions.onSuccessSave();
            });
        } else {
            PostbackActions.savePostback(params, (response) => {
                actions.onSuccessSave(response.id);
            });
        }
    },

    onSuccessSave(newCreateId) {
        const staticNames = UserStore.getTranslation().postbackPage.creatingEditing;

        if (!newCreateId) {
            CustomNotify(staticNames.successEdit);
        } else {
            CustomNotify(staticNames.successCreate);
            push(`/postback/edit/${newCreateId}`);
        }

    },

    clearErrors() {
        PostbackActions.clearErrors();
    }
};
